// extracted by mini-css-extract-plugin
export default {"button":"TzTMdvJUJKIvpS4tpg60"};